import { useEffect } from 'react';

/**
 * Browser-tab identity — forked from vCIP_droom_4.0/src/theme/documentTitle.ts (owner round
 * 2026-08-28 item 4). The tab carries the client's name ONLY when it came from the SERVED exchange
 * summary; the static title is restored on unmount so a dead link never keeps a name nobody served.
 */
export const STATIC_DOCUMENT_TITLE = 'Site verification';

export function brandedDocumentTitle(tenantName: string): string {
  return `${tenantName} — Site verification`;
}

export function useBrandedDocumentTitle(servedName: string | null | undefined): void {
  useEffect(() => {
    document.title = servedName ? brandedDocumentTitle(servedName) : STATIC_DOCUMENT_TITLE;
    return () => {
      document.title = STATIC_DOCUMENT_TITLE;
    };
  }, [servedName]);
}
